import ToolsPage from '@react/tools/components/ToolsPage';
import {
  defaultSearchInsightsFilter,
  ValidCalcTools,
  ValidChecklists,
} from '@sly/frontend/react/tools/constants/data';
import { createApiClient } from 'sly/services/api';
import apiEndpoints from 'sly/services/api/endpoints';

export default ToolsPage;

export async function getServerSideProps({
  query,
}: {
  query: {
    toc: string;
    city: string;
    state: string;
    roomType: string;
    toolName: ValidCalcTools | ValidChecklists;
  };
}) {
  const { api, store } = createApiClient(apiEndpoints);
  const { toc, city, state, roomType, toolName } = query || {};
  try {
    const actions = [
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      api.getSeniorLivingTools.asAction({
        'filters[slug][$eq]': toolName,
        'populate[articles][populate]': '*',
        'populate[faqs][populate]': '*',
        'populate[mainImage][populate]': '*',
      }),
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      api.getToolsPage.asAction({
        'populate[seniorLivingTools][populate]': '*',
        'populate[checklists][populate]': 'mainImage',
        'populate[seniorLivingTypes][populate]': 'mainImg',
      }),
    ];

    if (
      toolName === 'neighborhood-insights' ||
      toolName === 'compare-price-nearby'
    ) {
      actions.push(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        api.getSearchInsights.asAction({
          'care-type': defaultSearchInsightsFilter.careType,
          'filter[state]': state,
          'filter[city]': city,
          'filter[room-type]': defaultSearchInsightsFilter.roomType,
          include: defaultSearchInsightsFilter.include,
        })
      );
    }

    if (
      toc &&
      city &&
      state &&
      roomType &&
      toolName === 'senior-living-cost-calculator'
    ) {
      actions.push(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        api.getGeoGuides.asAction({
          city: city,
          state: state,
          toc: toc,
        })
      );
    }

    await Promise.all(actions.map(store.dispatch));
  } catch (e) {
    console.error(e);
    return {
      notFound: true,
    };
  }

  return {
    props: {
      initialApiState: store.getState(),
    },
  };
}
